import gql from 'graphql-tag';

import userFragment from '~/shared/graphql-queries/users/user-fragment';

const updateTelegramSettingsMutation = gql`
    mutation UpdateTelegramSettings($record: UpdateTelegramNotificationSettingsInput!) {
        updateTelegramSettings(record: $record) {
            ...UserFragment
        }
    }
    ${userFragment}
`;

export default updateTelegramSettingsMutation;
